import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent {

  currentYear: number = new Date().getFullYear();
  email: string = "";
  password: string = "";

  constructor(private authService: AuthService,
              private router: Router) { }

  login() {
    this.router.navigateByUrl('/login');
  }

  loginUtpl() {
    this.authService.loginMicrosoft()
  }

  register() {
    this.router.navigateByUrl('/register')
  }
}
